'use strict';

(function ($) {
    var launchInstafeed = function launchInstafeed() {
        var $el = $(".instagram-feed");

        if ($el.length) {
            var clientID = $el.data('client-id'),
                accessTOKEN = $el.data('access-token'),
                userID = $el.data('user-id'),
                total = 9;

            var feed = new Instafeed({
                get: "user",
                sortBy: 'most-recent',
                accessToken: accessTOKEN,
                clientId: clientID,
                userId: userID,
                limit: total,
                resolution: 'standard_resolution',
                template: '',
                success: function success(data) {
                    var $el = $('#instafeed');
                    if (window.matchMedia("(max-device-width: 667px)").matches) {
                        var templateMobile = '<div class="susy-col-12 susy-gutter instagram-mobile">' + '</div>';

                        $el.append(templateMobile);

                        var $template = $('.instagram-mobile');

                        for (var i = 1; i < total; i++) {
                            var firstImage = data.data[i]['images']['standard_resolution']['url'],
                                firstUrl = data.data[i]['link'];

                            $template.append('<a class="instagram-img-mobile" href="' + firstUrl + '" target="_blank"><div class="ratio-content"><img src="' + firstImage + '"></div></a>');
                        }

                        $template.owlCarousel({
                            items: 1,
                            margin: 20,
                            mouseDrag: false,
                            nav: false
                        });
                    } else {
                        var templateFirst = '<div class="susy-col-4 susy-gutter instagram-big">' + '</div>',
                            templateSecond = '<div class="susy-col-8 susy-gutter instagram-small">' + '</div>';

                        $el.append(templateFirst);
                        $el.append(templateSecond);

                        var $bigWrapper = $('.instagram-big'),
                            $smallWrapper = $('.instagram-small'),
                            firstImage = data.data[0]['images']['standard_resolution']['url'],
                            firstUrl = data.data[0]['link'];

                        $bigWrapper.append('<a href="' + firstUrl + '" target="_blank"><div class="ratio-content"><img class="instagram-img-big" src="' + firstImage + '"></div></a>');

                        for (var i = 1; i < total; i++) {
                            var firstImage = data.data[i]['images']['standard_resolution']['url'],
                                firstUrl = data.data[i]['link'];

                            $smallWrapper.append('<a class="instagram-img-small" href="' + firstUrl + '" target="_blank"><div class="ratio-content"><img src="' + firstImage + '"></div></a>');
                        }
                    }
                }
            });

            feed.run();
        }
    };

    var launchSliderDesktop = function launchSliderDesktop() {
        var $el = $('.categorie__slider-wrapper');

        if ($el.length) {
            var $prev = $('.prev-slide'),
                $next = $('.next-slide'),
                nitems = 4;

            if (window.matchMedia("(max-device-width: 769px)").matches) {
                nitems = 2;
            }

            if (window.matchMedia("(max-device-width: 560px)").matches) {
                nitems = 1;
            }

            $el.owlCarousel({
                items: nitems,
                margin: 20,
                mouseDrag: false,
                nav: false
            });

            $next.on('click', function (e) {
                $el.trigger('next.owl.carousel');
                e.preventDefault();
            });

            $prev.on('click', function (e) {
                $el.trigger('prev.owl.carousel');
                e.preventDefault();
            });
        }
    };

    var mobileMenu = function mobileMenu() {
        var mobileMenuBtn = $('.header__mobile-button');

        if (mobileMenuBtn.length) {
            mobileMenuBtn.on('click', function (e) {
                $('.header__mobile-menu').toggleClass('header__mobile-menu__open');

                e.preventDefault();
            });
        }
    };

    var youtubeLaunch = function youtubeLaunch() {
        var $el = $('.article__video');

        if ($el.length) {
            $el.on('click', function (e) {
                console.log('clicked');
                var $this = $(this).find('.ratio-content'),
                    $video = $this.find('.article__video-video');

                if (!$this.hasClass('js-video')) {
                    $this.addClass('js-video');
                    $video[0].src += "?autoplay=1";
                }
            });
        }
    };

    var initDataLink = function initDataLink() {
        $('body').on('mouseup.data-link-href', '[data-link-href], [data-link-closest][data-link-selector]', function dataLinkHrefClickHandler(e) {
            var link = $(this).attr("data-link-href");

            if (!link) {
                var closestSelector = $(this).attr("data-link-closest");
                var linkSelector = $(this).attr("data-link-selector");
                var $element = $(this).closest(closestSelector).find(linkSelector).first();

                link = $element.attr('href');
            }

            if (link) {
                // Middle Click
                if (e.which == 2) {
                    window.open(link, '_blank');
                }

                // Left Click + ctrl/cmd
                else if (e.which == 1 & (e.ctrlKey || e.metaKey)) {
                        window.open(link, '_blank');
                    }

                    // Left Click
                    else if (e.which == 1) {
                            window.location.href = link;
                        }
            }
        });
    };
    /*
        var initSiteSelector = function() {
            // Trigger the site selector
            $('body').on('click.site-selector-show', '.header__site-selector', function siteSelectorShow(e) {
                var isDesktop = $('.header__site-selector__item:not(.header__site-selector__item__selected):first').is(':visible');
    
                if (! isDesktop) {
                    $(this)
                        .clone(true)
                        .hide()
                        .removeClass('header__site-selector')
                        .addClass('site-selector')
                        .find('.header__site-selector__title')
                            .removeClass('header__site-selector__title')
                            .addClass('site-selector-title')
                            .end()
                        .find('.header__site-selector__item')
                            .removeClass('header__site-selector__item')
                            .addClass('site-selector-item')
                            .end()
                        .find('.header__site-selector__item__selected')
                            .removeClass('header__site-selector__item__selected')
                            .addClass('site-selector-item__selected')
                            .end()
                        .find('.header__site-selector__link')
                            .removeClass('header__site-selector__link')
                            .addClass('site-selector-link')
                            .end()
                        .find('.header__site-selector__link__selected')
                            .removeClasks('header__site-selector__link__selected')
                            .addClass('site-selector-link-selected')
                            .end()
                        .find('.header__site-selector__icon')
                            .remove()
                            .end()
                        .one('click.site-selector-close', function siteSelectorHide(e) {
                            if (! $(e.target).is('a')) {
                                $('.site-selector').fadeOut('fast', function siteSelectorHideFadeout() {
                                    $(this).remove();
                                })
                            }
                        })
                        .appendTo('body')
                        .fadeIn('fast')
                    ;
    
                    e.preventDefault();
                }
            });
        };
    */

    $(document).on('load', function ($) {
        launchInstafeed();
        launchSliderDesktop();
        mobileMenu();
        youtubeLaunch();
        initDataLink();
        //initSiteSelector();
    }(jQuery));
})(jQuery);